import { supabase } from '@/lib/supabase';

export interface TranscriptionPolicy {
  organization_id: string;
  enabled: boolean;
  all_meetings: boolean;
  owner_user_ids: string[];
  retention_months: number;
}

export interface MeetTranscriptionData {
  policy: TranscriptionPolicy;
  meet_level: { level: string; rank: number };
  users: { id: string; name: string | null; email: string | null; role: string | null; in_org: boolean; meetings_30d: number }[];
  usage_30d: { meetings: number; provider_cost_usd: number; credits: number };
  last_failure: { at: string; error_code: string } | null;
  concurrent_captures: number;
  last_change: { at: string; admin_user_id: string; admin_email: string } | null;
}

export function isTranscriptionForbidden(error: unknown): boolean {
  const e = error as { code?: string; message?: string } | null;
  return e?.code === '42501' || e?.message === 'forbidden';
}

export function transcriptionErrorReason(error: unknown): string {
  if (isTranscriptionForbidden(error)) return 'רק מנהל-על יכול לשנות הגדרות תמלול.';
  const message = (error as { message?: string } | null)?.message;
  const reasons: Record<string, string> = {
    invalid_policy: 'יש לבחור הגדרות תקינות ותקופת שמירה בין חודש אחד ל־120 חודשים.',
    organization_not_found: 'הארגון לא נמצא.',
    selected_user_not_in_org: 'אחד המשתמשים שנבחרו כבר לא שייך לארגון. יש לטעון מחדש את ההגדרות.',
  };
  return (message && reasons[message]) || 'לא ניתן ליצור קשר עם השרת. נסה שוב.';
}

export const meetTranscriptionApi = {
  async get(orgId: string): Promise<MeetTranscriptionData> {
    const { data, error } = await supabase.rpc('admin_meet_transcription_get', { p_org: orgId });
    if (error) throw error;
    return data as MeetTranscriptionData;
  },
  async set(orgId: string, policy: TranscriptionPolicy): Promise<MeetTranscriptionData> {
    const { data, error } = await supabase.rpc('admin_meet_transcription_set', {
      p_org: orgId,
      p_enabled: policy.enabled,
      p_all_meetings: policy.all_meetings,
      p_owner_user_ids: [...policy.owner_user_ids],
      p_retention_months: policy.retention_months,
    });
    if (error) throw error;
    return data as MeetTranscriptionData;
  },
};
